import {
    keyIssueUpdateModel,
    keyIssueUpdateImage
} from "../../../actions/key-issue-actions"

import buildItemConnector from "../../common/build-item-connector"

export default buildItemConnector(
    "keyIssues",
    false,
    keyIssueUpdateModel,
    keyIssueUpdateImage
)
